jQuery(document).ready(function ($) {

    $('.faq__item, .accordeon__item').on('click', '.main-title', function() {
        $(this)
            .toggleClass('active')
            .next()
            .stop().slideToggle()
    });

    $('.faq-categories li').on('click', function (e) {
        var id = $(this).data("id");
        $('.faq-categories li').removeClass('active');
        $('.category-section').removeClass('active');
        $('.category-section[data-id="' + id + '"]').addClass('active');
        $(this).addClass('active');
        $('.faq-info-title').hide();
    });

    if ($(window).width() < 993) {

        $('.categories__item').click(function () {
            $('html, body').animate({
                scrollTop: $('.faq-overview__sections').offset().top - 100
            }, 600);
        });
    }
});